import { render } from "./BulkRemovalView.vue?vue&type=template&id=963ef056&scoped=true"
import script from "./BulkRemovalView.vue?vue&type=script&lang=js"
export * from "./BulkRemovalView.vue?vue&type=script&lang=js"

import "./BulkRemovalView.vue?vue&type=style&index=0&id=963ef056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963ef056"]])

export default __exports__